import { combineReducers } from "redux";
//
import ajax from "./modules/ajax";
import auth from "./modules/auth";
import booking from "./modules/booking";
import brands from "./modules/brands";
import countries from "./modules/countries";
import filters from "./modules/filters";
import flags from "./modules/flags";
import intl from "./modules/intl";
import locations from "./modules/locations";
import modal from "./modules/modal";
import models from "./modules/models";
import places from "./modules/places";
import rates from "./modules/rates";
import reviews from "./modules/reviews";
import services from "./modules/services";
import uuid from "./modules/uuid";
import videos from "./modules/videos";

export default combineReducers({
  ajax,
  auth,
  booking,
  brands,
  countries,
  filters,
  flags,
  intl,
  locations,
  modal,
  models,
  places,
  rates,
  reviews,
  services,
  uuid,
  videos,
});
